"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onchainMonkey = void 0;
const BalanceOfABI_json_1 = __importDefault(require("../abi/BalanceOfABI.json"));
const ethers_1 = require("ethers");
const parseBlockTag_1 = require("../utils/parseBlockTag");
/**
 * Custom voting strategy for the OCM community
 */
const onchainMonkey = () => {
    return async (userAddress, communityAddress, blockTag, provider) => {
        const contracts = [
            '0x86cc280d0bac0bd4ea38ba7d31e895aa20cceb4b',
            '0x960b7a6bcd451c9968473f7bbfd9be826efd549a', // ocm
        ].map(address => new ethers_1.Contract(address, BalanceOfABI_json_1.default, provider));
        const balances = await Promise.all(contracts.map(contract => contract.balanceOf(userAddress, {
            blockTag: (0, parseBlockTag_1.parseBlockTag)(blockTag),
        })));
        const [karma, ocm] = balances.map(bal => bal.toNumber());
        return karma + ocm + Math.min(karma, ocm);
    };
};
exports.onchainMonkey = onchainMonkey;
